import { useSelector } from "react-redux";
import type { Fare, FareSliceDeparture } from "@b2bportal/air-shopping-api";
import { passengerCountSelector } from "@b2bportal/core-flights";
import { useReturnFlightCfarBatchFetch } from "@b2bportal/core-flights-cfar-offers";
import type { IFlightListData } from "@b2bportal/core-types";
import { fetchBatchRbcCfarOffers } from "./fetchBatchRbcCfarOffers";
import { useShouldPopulateFarePriceBreakdown } from "./useShouldPopulateFarePriceBreakdown";

export const useReturnCfarBatchFetch = ({
  flightList,
}: {
  flightList: IFlightListData<Fare | FareSliceDeparture>[];
}) => {
  const passengers = useSelector(passengerCountSelector);
  const shouldPopulateFarePriceBreakdown =
    useShouldPopulateFarePriceBreakdown();

  return useReturnFlightCfarBatchFetch({
    flightList,
    passengers,
    fetchBatchCfarOffers: fetchBatchRbcCfarOffers,
    shouldPopulateFarePriceBreakdown,
  });
};
